{
  "AGENT_MGMT": {
    "HEADER": "Agentes",
    "HEADER_BTN_TXT": "Añadir agente",
    "LOADING": "Se están listando los agentes",
    "DESCRIPTION": "Un agente es miembro de su equipo de atención al cliente, quién puede ver y responder a los mensajes del usuario.  La siguiente lista muestra todos los agentes en su cuenta.",
    "LEARN_MORE": "Aprender acerca de roles de usuario",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrador",
      "AGENT": "Agente"
    },
    "COUNT": "{n} agent | {n} agents",
    "LIST": {
      "404": "No hay agentes asociados a esta cuenta",
      "TITLE": "Administrar agentes en tu equipo",
      "DESC": "Puedes añadir/eliminar agentes a/en tu equipo.",
      "NAME": "Nombre",
      "EMAIL": "Correo electrónico",
      "STATUS": "Estado",
      "ACTIONS": "Acciones",
      "VERIFIED": "Verificado",
      "VERIFICATION_PENDING": "Verificación pendiente",
      "AVAILABLE_CUSTOM_ROLE": "Permisos personalizados de rol disponibles"
    },
    "ADD": {
      "TITLE": "Añadir agente a tu equipo",
      "DESC": "Puedes añadir personas que podrán manejar el soporte para tus bandejas de entrada.",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "FORM": {
        "NAME": {
          "LABEL": "Nombre del agente",
          "PLACEHOLDER": "Introduce el nombre del agente"
        },
        "AGENT_TYPE": {
          "LABEL": "Tipo de agente",
          "PLACEHOLDER": "Seleccione un tipo",
          "ERROR": "El tipo de agente es obligatorio"
        },
        "EMAIL": {
          "LABEL": "Dirección de correo",
          "PLACEHOLDER": "Por favor, introduzca una dirección de correo electrónico del agente"
        },
        "SUBMIT": "Añadir agente"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agente añadido correctamente",
        "EXIST_MESSAGE": "El correo electrónico del agente ya está en uso, por favor intente otra dirección de correo electrónico",
        "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eliminar",
      "API": {
        "SUCCESS_MESSAGE": "Agente eliminado correctamente",
        "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
      },
      "CONFIRM": {
        "TITLE": "Confirmar eliminación",
        "MESSAGE": "¿Está seguro de eliminar ",
        "YES": "Sí, eliminar ",
        "NO": "No, mantenerlo "
      }
    },
    "EDIT": {
      "TITLE": "Editar agente",
      "FORM": {
        "NAME": {
          "LABEL": "Nombre del agente",
          "PLACEHOLDER": "Por favor, introduzca un nombre del agente"
        },
        "AGENT_TYPE": {
          "LABEL": "Tipo de agente",
          "PLACEHOLDER": "Por favor, seleccione un rol",
          "ERROR": "El tipo de agente es obligatorio"
        },
        "EMAIL": {
          "LABEL": "Dirección de email",
          "PLACEHOLDER": "Por favor, introduzca una dirección de correo electrónico del agente"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Disponibilidad",
          "PLACEHOLDER": "Por favor, seleccione un estado de disponibilidad",
          "ERROR": "La disponibilidad es necesaria"
        },
        "SUBMIT": "Editar agente"
      },
      "BUTTON_TEXT": "Editar",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Agente actualizado correctamente",
        "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Restablecer contraseña",
        "ADMIN_SUCCESS_MESSAGE": "Se ha enviado un correo electrónico con instrucciones para restablecer la contraseña al agente",
        "SUCCESS_MESSAGE": "Contraseña del agente restablecida con éxito",
        "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
      }
    },
    "SEARCH_PLACEHOLDER": "Buscar agentes...",
    "NO_RESULTS": "No agents found matching your search",
    "SEARCH": {
      "NO_RESULTS": "No se encontraron resultados."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Ninguna",
      "TITLE": {
        "AGENT": "Seleccionar agente",
        "TEAM": "Seleccionar equipo"
      },
      "LIST": {
        "NONE": "Ninguna"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "No se encontraron agentes",
          "TEAM": "No se encontraron equipos"
        },
        "PLACEHOLDER": {
          "AGENT": "Buscar agentes",
          "TEAM": "Buscar equipos",
          "INPUT": "Búsqueda por agentes"
        }
      }
    }
  }
}
